goog.provide("shadow.js.shim.module$date_fns$locale$it$default");
shadow.js.shim.module$date_fns$locale$it$default = esm_import$date_fns$locale$it.default;
